// Utilities
import { gcAccessToken, gcEnvironment, fetchWrap } from '../../components/common/utilities/fetchWrap';
import config from '../../config';

/**
* @async
* @description Get's the current integration types from genesys cloud api.
* @return {Promise<object>} { data, count, correlationIds, httpResults }
*/
export const dashboardDetails = async () => {
  const urlbase = config.endpoints.endpoint;
  const url = `${urlbase}/dashboard`;
  const token = gcAccessToken();
  const gcEnv = gcEnvironment();
 
  return await fetchWrap(
    {url,
    options: {
      method: "GET",
    },
    token,
    auth: true,
    cookies: false,
    headerOptions: {
      token: token,
      env: gcEnv,
      tokensource:'purecloud'
    }
  }
  );
}

export const knowledgeBaseSummary = async () => {
  const urlbase = config.endpoints.endpoint;
  const url = `${urlbase}/knowledgebase/query`;
  const token = gcAccessToken();
  const gcEnv = gcEnvironment();
 
  return await fetchWrap(
    {url,
    options: {
      method: "GET",
    },
    token,
    auth: true,
    cookies: false,
    headerOptions: {
      token: token,
      env: gcEnv,
      tokensource:'purecloud'
    }
  }
  );
}

export default dashboardDetails;